import {Component, Input, OnInit} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss']
})
export class AlertBoxComponent implements OnInit {

  @Input() type: string = 'info';
  @Input() title?: string;
  @Input() bold: boolean = false;

  private titleHtml: SafeHtml;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.titleHtml = this.sanitizer.bypassSecurityTrustHtml(
      this.allowOnlyBr(this.title)
    );
  }

  get alertClass(): string {
    return `alert-box alert-box--${this.type}`;
  }

  private allowOnlyBr(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/&lt;br\s*\/?&gt;/gi, '<br>');
  }

}
